/** Адрес копии SDK на нашем домене. Лежит в `public/vendor/`. */
const LOCAL_SDK_URL = '/vendor/telegram-web-app.js';

/** Сколько ждём загрузку копии, прежде чем сдаться. */
const LOAD_TIMEOUT_MS = 5_000;

/**
 * Догружает SDK Telegram с НАШЕГО домена, если основной не приехал.
 *
 * ЗАЧЕМ. Прокси MTProto, через который часть игроков пользуется Telegram,
 * возит только протокол Telegram. HTTP мини-аппа идёт мимо него, напрямую,
 * и если у игрока `telegram.org` недоступен, `window.Telegram` не появится.
 * Приложение при этом загружается и работает — но говорит «доступно только
 * внутри Telegram», хотя игрок именно там. 09.09.2026 так не могли войти
 * четверо, при полностью доступном нашем домене.
 *
 * ЧЕМ ЭТО ОТЛИЧАЕТСЯ ОТ `onerror` В index.html. Тот отвечает на вопрос
 * «не упал ли запрос» — и отвечает верно, включая таймаут. Здесь вопрос
 * другой: «появилось ли то, что нам нужно». Между ними есть зазор —
 * запрос может завершиться УСПЕШНО, отдав не SDK: на фильтрованных сетях
 * прозрачный прокси или страница-заглушка возвращают 200 с HTML вместо
 * JavaScript. `onerror` при этом молчит, а `window.Telegram` не появится.
 *
 * Поэтому основная защита — здесь, а `onerror` лишь экономит круг,
 * подставляя копию ещё во время разбора страницы.
 *
 * ПОЧЕМУ НЕ ЗАМЕНИТЬ ОСНОВНОЙ ИСТОЧНИК КОПИЕЙ. Копия замораживает версию
 * и со временем отстанет от новых клиентов. Поэтому она запасной путь,
 * а не замена: у кого `telegram.org` доступен, тот получает свежий SDK.
 *
 * Молчит при неуспехе намеренно: не сумели догрузить — приложение покажет
 * ту же ошибку, что и раньше. Подменять её своей значило бы прятать
 * причину.
 */
export async function ensureTelegramSdk(): Promise<void> {
  if (window.Telegram?.WebApp) return;

  await new Promise<void>((resolve) => {
    const script = document.createElement('script');
    let done = false;

    const finish = (): void => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      resolve();
    };

    // Ждём не бесконечно: наш домен тоже может быть недоступен, и
    // приложение обязано дойти до экрана ошибки, а не висеть пустым
    const timer = setTimeout(finish, LOAD_TIMEOUT_MS);

    script.src = LOCAL_SDK_URL;
    script.onload = finish;
    script.onerror = finish;
    document.head.appendChild(script);
  });
}
